import { useCallback } from 'react';
import { ensureValidAccessToken, getSocket } from '@connect-x-app/hybrid-data-access';
import { AppConfig } from '@connect-x-app/shared-types';
import { Socket } from 'socket.io-client';

import { useSocketStore } from '../../stores';

type UseSocketResult = {
  connectSocket: () => Promise<void>;
  initializeSocket: ({ appConfig, connectServiceApiHost }: { appConfig: AppConfig; connectServiceApiHost: string }) => void;
  socket: Socket | null;
};

export const useSocket = (): UseSocketResult => {
  const { setSocket, socket } = useSocketStore();

  const initializeSocket = useCallback(
    ({ appConfig, connectServiceApiHost }: { appConfig: AppConfig; connectServiceApiHost: string }) => {
      setSocket(getSocket(connectServiceApiHost, appConfig));
    },
    [setSocket],
  );

  const connectSocket = useCallback(async () => {
    if (socket && !socket.active) {
      await ensureValidAccessToken();
      socket.connect();
    }
  }, [socket]);

  return { connectSocket, initializeSocket, socket };
};
